import { config } from '../config';

export const API_ENDPOINT = config.VITE_API_ENDPOINT;
export const SUBSCRIPTION_ENDPOINT = config.VITE_SUBSCRIPTION_ENDPOINT;
export const GRAPHQL_ENDPOINT = `${API_ENDPOINT}/graphql`;
export const refreshToken = async () => {
  return await fetch(`${API_ENDPOINT}/refreshToken`, {
    method: 'POST',
    credentials: 'include'
  });
};
